import { PlusIcon } from "lucide-react";

import { trpc } from "@blis/trpc/react";

import { Link } from "@/components/Link";
import { Badge } from "@/components/ui/badge";
import { usePersistedAdminGridOptions } from "../../utils/gridState";
import { AdminGrid } from "../AdminGrid";
import { TableFilterRow } from "../TableFilterRow";

export function FieldsTable() {
  const { data } = trpc.admin.sampleFieldSpec.list.useQuery();

  const fieldSpecs = data ?? [];

  const { options, filterTextProps } = usePersistedAdminGridOptions(
    "fieldSpecs",
    fieldSpecs,
    [
      {
        field: "name",
        headerName: "Field",
        cellRenderer: (params) => (
          <Link to="/admin/tubes/fields/$id/edit" params={{ id: params.id }}>
            {params.name}
          </Link>
        ),
        cellRendererParams: (params) => ({
          name: params.data.name,
          id: params.data.id,
        }),
      },
      {
        field: "type",
        headerName: "Type",
        cellRenderer: (params) => <Badge>{params.data.type}</Badge>,
      },
    ],
    { sideBar: undefined },
  );

  return (
    <>
      <TableFilterRow inputProps={filterTextProps}>
        <Link to="/admin/tubes/fields/new" asButton>
          <PlusIcon data-slot="icon" />
          Add field
        </Link>
      </TableFilterRow>
      <AdminGrid {...options} />
    </>
  );
}
